var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityDialog',_vm._b({ref:"entityDialog",on:{"setNewEntity":_vm.handleEntityCreated}},'EntityDialog',_vm.companyUserDialog,false))}
var staticRenderFns = []

export { render, staticRenderFns }